<section class="home-main-sec flex-center">
  <div class="container text-center">
    <div class="text-container">
      <h1 *ngIf="!_userService.current_user">Power-up your practice</h1>
      <p class="fs16 mb-lg text-center" *ngIf="!_userService.current_user">
        Empowering Medical Offices with Seamless Patient Engagement and Care Management Solutions.
      </p>

      <!-- Embedded Login Form for Unauthenticated Users -->
      <div class="login-container" *ngIf="!_userService.current_user">
        <app-login [isEmbedded]="true"></app-login>
      </div>

      <!-- Links for Authenticated Users -->
      <div *ngIf="_userService.current_user" class="authenticated-view mt-lg">
        <h2 class="text-secondary">Welcome back, {{ _userService.current_user.first_name }}!</h2>
        <p class="mb-lg fs18">You are already logged in.</p>

        <div class="pic-holder p-lg mt-xl mb-xl">
          <div class="user-profile-pic thumbnail"
               [ngStyle]="{'background-image': 'url(' + _userService.current_user?.profile_pic + ')'}">
          </div>
        </div>
        <span *ngIf="_userService.current_user?.isPracticeUser">
      <a href="/enterprise/home/dashboard" class=" btn fs16 btn-secondary">Go to Dashboard</a></span>
        <span *ngIf="_userService.current_user?.isPatient">
          <a [routerLink]="['/patients',_userService.current_user.profileable_id]" class="btn btn-secondary fs16">See Your Profile</a></span>
      </div>

    </div>
  </div>
</section>
